import React, { useState, useRef, useEffect } from 'react'
import '../css/map.css'
import DownloadFile from './DownloadFile';
import Map1 from './Map1';
import AllDistrict from '../shapefiles/AllDistrict.json'
import AllLocalAdmin from '../shapefiles/AllLocalAdmin.json'

const Drought = () => {
    
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    let currentDateObj = new Date();
    let NcurrentDateObj = new Date();
    // console.log(currentDate,'dat')
    // currentDateObj.setDate(currentDateObj.getDate() + 7);
    // console.log(currentDateObj);

    currentDateObj.setDate(currentDateObj.getDate() - (currentDateObj.getDay()+4) % 7);
    let date = `${monthNames[currentDateObj.getMonth()]} ${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}, ${currentDateObj.getFullYear()}`;

    let currentDate = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`

    NcurrentDateObj.setDate(NcurrentDateObj.getDate() - (NcurrentDateObj.getDay()+4) % 7);
    NcurrentDateObj.setDate(NcurrentDateObj.getDate() + 7)
    let nextDate = `${NcurrentDateObj.getFullYear()}${(NcurrentDateObj.getMonth() < 10 ? '0' : '') + (NcurrentDateObj.getMonth() + 1)}${(NcurrentDateObj.getDate() < 10 ? '0' : '') + (NcurrentDateObj.getDate())}`
    console.log(nextDate, currentDate, "next");
    const [rname, setRname] = useState('Current');
    const [nname, setNname] = useState('Next Week');
    const [dates, setDates] = useState(currentDate);
    const [ndates, setNdates] = useState(nextDate);
    const handleChange = (e) => {
        const nae = e.target.value
        setRname(nae);
        if (nae === '1W') {
            currentDateObj.setDate(currentDateObj.getDate() - 7);
            let oneWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            setDates(oneWeek)
        }
        else if (nae === '2W') {
            currentDateObj.setDate(currentDateObj.getDate() - 14);
            let twoWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            setDates(twoWeek)
        }
        else if (nae === '3W') {
            currentDateObj.setDate(currentDateObj.getDate() - 21);
            let threeWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            setDates(threeWeek)
        }
        else if (nae === '1M') {
            currentDateObj.setMonth(currentDateObj.getMonth() - 1)
            let oneMonth = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            setDates(oneMonth)
        }
        else if (nae === '3M') {
            currentDateObj.setMonth(currentDateObj.getMonth() - 2)
            let threeMonth = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(threeMonth);
            setDates(threeMonth)
        }
        else if (nae === '6M') {
            currentDateObj.setMonth(currentDateObj.getMonth() - 5)
            let sixMonth = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth())}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(sixMonth)
            setDates(sixMonth)
        }
        else if (nae === '1Y') {
            let oneYear = `${currentDateObj.getFullYear() - 1}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(oneYear)
            setDates(oneYear)
        }
        else {
            setDates(currentDate);
        }
    }


    const handleChange1 = (e) => {
        const val = e.target.value
        setNname(val);
        if (val === '2W') {
            currentDateObj.setDate(currentDateObj.getDate() + 14);
            let NtwoWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(NtwoWeek);
            setNdates(NtwoWeek)
        }
        else if (val === '3W') {
            currentDateObj.setDate(currentDateObj.getDate() + 21);
            let NthreeWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(NthreeWeek);
            setNdates(NthreeWeek)
        }
        else if (val === '1M') {
            currentDateObj.setMonth(currentDateObj.getMonth() + 1)
            let NoneWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(NoneWeek);
            setNdates(NoneWeek)
        }
        else if (val === '2M') {
            currentDateObj.setMonth(currentDateObj.getMonth() + 2)
            let NtwoWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(NtwoWeek);
            setNdates(NtwoWeek)
        }
        else if (val === '3M') {
            currentDateObj.setMonth(currentDateObj.getMonth() + 3)
            let NthreeWeek = `${currentDateObj.getFullYear()}${(currentDateObj.getMonth() < 10 ? '0' : '') + (currentDateObj.getMonth() + 1)}${(currentDateObj.getDate() < 10 ? '0' : '') + (currentDateObj.getDate())}`
            console.log(NthreeWeek);
            setNdates(NthreeWeek)
        }
        else {
            setNdates(nextDate);
        }
    }

    // const [getMapMethodCall, setGetMapMethodCall] = useState(0);





    const [map, setMap] = useState(null);
    const [map1, setMap1] = useState(null);

    const geojsonRef = useRef();
    const geojsonRef1 = useRef();
    const [featureId, setFeatureId] = useState(null);
    const [featureId1, setFeatureId1] = useState(null);

    let i = true;
    let j = 0;

    function getName(feature, layer) {
        if (feature.properties.ADM0 && feature.properties.ADM1) {
            layer.bindPopup(feature.properties.name);
        }
        else if (feature.properties.ADM1 && feature.properties.ADM2) {
            layer.bindPopup(feature.properties.Dist);
        }
        else if (feature.properties.ADM2 && feature.properties.ADM3) {
            layer.bindPopup(feature.geometry.Local);
        }
    }


    const handleEachFeature = (feature, layer) => {
        getName(feature, layer);

        // fet = feature;
        // lay = layer;

        layer.on('mouseover', function (e) {
            this.openPopup();
            if (j < 2) {
                this.setStyle({
                    fillColor: 'blue'
                });

            }
        });
        layer.on('mouseout', function () {
            this.closePopup();
            if (j < 2) {
                this.setStyle({
                    fillColor: 'transparent',
                    color: 'black',
                    fillOpacity: 0.2,
                });
            }
        });

        layer.on({
            click: (e) => {
                j++;
                console.log("e::::", e);
                if (i) {
                    setFeatureId(feature.properties.ADM1);
                    setFeatureId1(feature.properties.ADM1);
                    map.fitBounds(e.target.getBounds());
                    map1.fitBounds(e.target.getBounds());
                    geojsonRef1.current.clearLayers();
                    geojsonRef.current.clearLayers();
                    i = false;
                }
                else if (i === false && feature.properties.ADM2 !== undefined) {
                    setFeatureId(feature.properties.ADM2);
                    setFeatureId1(feature.properties.ADM2);
                    map.fitBounds(e.target.getBounds());
                    map1.fitBounds(e.target.getBounds());
                    geojsonRef.current.clearLayers();
                    geojsonRef1.current.clearLayers();
                    i = null
                }
            }
        });
    };






    useEffect(() => {
        if (!featureId || !geojsonRef.current) return;
        if (!featureId1 || !geojsonRef1.current) return;

        geojsonRef.current.eachLayer((layer) => {
            layer.setStyle({
                opacity: 0.5,
                weight: 0
            });
        }); // inherited from LayerGroup
        geojsonRef1.current.eachLayer((layer) => {
            layer.setStyle({
                opacity: 0.5,
                weight: 0
            });
        });
        const newDistricts = AllDistrict.features.filter((district) => {
            return district.properties.ADM1 === featureId;
        });

        const newLocal = AllLocalAdmin.features.filter((local) => {
            return local.properties.ADM2 === featureId;
        })
        geojsonRef.current.addData(newDistricts);
        geojsonRef.current.addData(newLocal);
        geojsonRef1.current.addData(newDistricts);
        geojsonRef1.current.addData(newLocal);
    }, [featureId, featureId1]);








    return (
        <>
            <div className="mt-14 text-4xl mx-[2.50rem] sm:px-6 lg:px-8 flex justify-center items-center font-Gill font-medium">
                {/* Left side  */}
                <div className='flex space-x-7'>
                    <div className='left'>
                        Drought Monitor <br />
                        <h3 className='text-xl'> Map Update: {date} </h3>
                        <div className="flex ">
                            <div className="mt-4">
                                {/* Create Radio Buttons  */}
                                <div className="mt-2 text-lg">
                                    <label className="inline-flex items-center" title='One year ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="1Y" onChange={handleChange} />
                                        <span className="ml-2">1Y</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='Six months ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="6M" onChange={handleChange} />
                                        <span className="ml-2">6M</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='Three months ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="3M" onChange={handleChange} />
                                        <span className="ml-2">3M</span>
                                    </label><label className="inline-flex items-center ml-6" title='One month ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="1M" onChange={handleChange} />
                                        <span className="ml-2">1M</span>
                                    </label><label className="inline-flex items-center ml-6" title='Three weeks ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="3W" onChange={handleChange} />
                                        <span className="ml-2">3W</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='Two weeks ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="2W" onChange={handleChange} />
                                        <span className="ml-2">2W</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6 " title='One week ago'>
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="1W" onChange={handleChange} />
                                        <span className="ml-2">1W</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6">
                                        <input type="radio" className="form-radio h-6 w-6" name="time" value="Current" onChange={handleChange} defaultChecked />
                                        <span className="ml-2">Current</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                        {/* Display map from map component  */}
                        <div className=' mt-4  h-[78vh] w-[43rem] p-2 px-1' id='mapss'>

                            {/* <Map val={true} /> */}
                            <Map1 val={true} fileName={rname} path={'nowcast'} dates={dates} refe={geojsonRef} map={map} setmap={setMap} handleEachFeature={handleEachFeature} />

                        </div>
                        <hr className='w-1/2 mx-[12rem] my-4 ' />
                    </div>

                    {/* Right side  */}
                    <div className='right'>
                        Drought Forecast <br />
                        <h3 className='text-xl'> Map Update: {date} </h3>
                        <div className="flex ">
                            <div className="mt-4">
                                <div className="mt-2 text-lg">
                                    {/* Radio Buttons  */}
                                    <label className="inline-flex items-center">
                                        <input type="radio" className="form-radio h-6 w-6 " name="timeFor" value="Next Week" onChange={handleChange1} defaultChecked />
                                        <span className="ml-2">Next Week</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='For next two weeks'>
                                        <input type="radio" className="form-radio h-6 w-6" name="timeFor" value="2W" onChange={handleChange1} />
                                        <span className="ml-2">2W</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='For next three weeks'>
                                        <input type="radio" className="form-radio h-6 w-6" name="timeFor" value="3W" onChange={handleChange1} />
                                        <span className="ml-2">3W</span>
                                    </label><label className="inline-flex items-center ml-6" title='For next one Month'>
                                        <input type="radio" className="form-radio h-6 w-6" name="timeFor" value="1M" onChange={handleChange1} />
                                        <span className="ml-2">1M</span>
                                    </label><label className="inline-flex items-center ml-6" title='For next two Months'>
                                        <input type="radio" className="form-radio h-6 w-6" name="timeFor" value="2M" onChange={handleChange1} />
                                        <span className="ml-2">2M</span>
                                    </label>
                                    <label className="inline-flex items-center ml-6" title='For next three Months'>
                                        <input type="radio" className="form-radio h-6 w-6" name="timeFor" value="3M" onChange={handleChange1} />
                                        <span className="ml-2">3M</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* Display map from map component  */}
                        <div className=' mt-4 h-[78vh] w-[43rem] p-2 px-1 ' id='mapss' >
                            {/* <Map val={false} /> */}
                            <Map1 val={false} fileName={nname} path={'forecast'} dates={ndates} refe={geojsonRef1} map={map1} setmap={setMap1} handleEachFeature={handleEachFeature} />
                        </div>
                        <hr className='w-1/2 mx-[12rem] mt-4 ' />
                    </div>


                </div>
            </div>
            <div className='flex flex-col font-Gill font-medium'>

                <div className='flex'>


                    <h1 className='text-2xl mx-[3.50rem] mb-4 items-start'>Drought Intensity</h1>
                    <h1 className='text-2xl mx-44 mb-4 items-start'>Map Download</h1>
                </div>

                <div className=' flex'>
                    <div className='flex mx-[3rem] '>

                        <div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mx-3 mt-2 bg-[#BDDA57] '></div> <div className='text-[16px] mt-3 '>No Drought  </div></div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mx-3 mt-2 bg-[#FFFF00]'></div> <div className='text-[16px] mt-3'>Abnormal Drought  </div></div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mx-3 mt-2 bg-[#FCD37F]'></div> <div className='text-[16px] mt-3'>Moderate Drought  </div></div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mx-3 mt-2 bg-[#FFAA00]'></div> <div className='text-[16px] mt-3'>Severe Drought  </div></div>


                            <div className='flex'>  <div className='border-2 w-10 h-8 mr-3 mx-3 mt-2 bg-[#E60000]'></div> <div className='text-[16px] mt-3'>Extreme Drought  </div></div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mr-3 mx-3  mt-2 bg-[#730000]'></div> <div className='text-[16px] mt-3'>Exceptional Drought  </div></div>
                            <div className='flex'>  <div className='border-2 w-10 h-8 mr-3 mx-3  mt-2 mb-3 '></div> <div className='text-[16px] mt-3'>No Data  </div></div>
                        </div>

                    </div>

                    <div className='my-5 ml-[10rem] '>
                        <DownloadFile fileName={rname} date={dates} path={'nowcast'} name={'Download Monitor TIF File'} />
                    </div>

                    <div className='border-l-2 h-48 mx-auto'> </div>
                    <div className='flex flex-col'>


                        <h1 className='text-2xl mx-44 mb-4 -mt-11'>Map Download</h1>
                        <div className='my-5 ml-[170px]'>
                            <DownloadFile fileName={nname} date={ndates} path={'forecast'} name={'Download Forecast TIF File'} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Drought